import {useEffect, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator, AlertModal, CCText,
    View
} from '../../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import AppConfig from '../../../../AppConfig';


import {useNavigate, useParams} from "react-router-dom";

import {GetAuthObject} from "../../../../authentication/AuthFunctions";
import MenuEditorTopBar from "./Components/MenuEditorTopBar";
import PollConstants from "../../Poll/PollConstants";
import {
    ThemeButton
} from "../../../../custom-packages/react-button-package/ButtonPackage";
import Styles from "../../../../Styles";
import Poll from "../../../../models/poll/Poll";
import MenuEditorBottomBar from "./Components/MenuEditorBottomBar";
import DropdownMenu from "../../../../custom-packages/dropdown-menu/DropdownMenu";
import GearIcon from "../../../../assets/custom-icons/GearIcon";


const TMenuPollScreen = {
    // English
    "enUS": {
        // FOR POLLING
        'POLL': 'Poll',
        'POLL_DESC': 'Gather information from your clients',
        'CREATE': 'Create',
        'DELETE': 'Delete',
        'DELETE_TEXT': 'If you delete this poll all associated answers will be deleted too',
        'EDIT': 'Edit',
        'SEE_RESULTS': 'See Results',
        'CANCEL': 'Cancel',
        'NAME': 'Name',
        'QUESTIONS': 'Questions',
        'SCORE': 'Score (1-5)',
        'OPEN': 'Open',
        'NO_POLL': 'Create a poll to retrieve feedback from your clients',
    },
    // Spanish
    "esMX": {
        // FOR POLLING
        'POLL': 'Encuesta',
        'POLL_DESC': 'Recolecta la opinión de tus clientes',
        'CREATE': 'Crear',
        'DELETE': 'Eliminar',
        'DELETE_TEXT': 'Si eliminas esta encuesta, se eliminarán las respuestas asociadas a ella.',
        'EDIT': 'Editar',
        'SEE_RESULTS': 'Ver Resultados',
        'CANCEL': 'Cancelar',
        'NAME': 'Nombre',
        'QUESTIONS': 'Preguntas',
        'SCORE': 'Calificación (1-5)',
        'OPEN': 'Abierta',
        'NO_POLL': 'Crea una encuesta para obtener información de tus clientes',
    }
}

const MenuPollScreen = (props) => {
    const auth = GetAuthObject();
    const navigate = useNavigate();

    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const params = useParams()
    const id = params.id;

    const [loading, setLoading] = useState(true);
    const [poll, setPoll] = useState<Poll | null>(null);

    useEffect(() => {
        const f = async () => {
            const response = await fetch(AppConfig.URL + "/Menu/FetchPoll/" + id, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                }
            });

            const json = await response.json();

            setPoll(json.poll);

            setLoading(false);
        };

        f();
    }, [id]);

    if (loading)
        return <View style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start'}}>
            <MenuEditorTopBar
                menuID={id}
            />
            <MenuEditorBottomBar
                menuID={id}
            />
            <View style={{height: 70}}></View>
            <ActivityIndicator style={{marginTop: 170}}/>
        </View>

    return <View>
        <MenuEditorTopBar
            menuID={id}
        />
        <MenuEditorBottomBar
            menuID={id}
        />
        <View style={{height: 70}}></View>
        <View className={'row'}>
            <View className={'col-12'}>
                <View>
                    <View
                        style={{}}
                    >
                        <h1
                            style={{marginBottom: 0}}
                        >
                            {TMenuPollScreen[AppConfig.lang].POLL}
                        </h1>
                        <CCText
                            style={{
                                color: '#666666',
                                fontStyle: 'italic',
                                fontSize: '1.15rem'
                            }}
                        >
                            {TMenuPollScreen[AppConfig.lang].POLL_DESC}
                        </CCText>
                    </View>
                    <View
                        className={'card'}
                        style={{
                            marginTop: 15
                        }}
                    >
                        {
                            poll ?
                                <View
                                    style={{
                                        padding: 15,
                                        borderBottom: '1px solid #dddddd',
                                    }}
                                >
                                    <View
                                        style={{
                                            flexDirection: 'row',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <View>
                                            <CCText
                                                style={{
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {TMenuPollScreen[AppConfig.lang].NAME}
                                            </CCText>
                                            <CCText>
                                                {poll.pol_name}
                                            </CCText>
                                        </View>
                                        <View>
                                            {deleting ?
                                                <ActivityIndicator/>
                                                :
                                                <DropdownMenu
                                                    buttonText={<GearIcon/>}
                                                    options={[
                                                        {
                                                            text: TMenuPollScreen[AppConfig.lang].EDIT,
                                                            onPress: () => {
                                                                navigate('/admin/survey/creator?pollID=' + poll.pol_id + '&menuID=' + id)
                                                            }
                                                        },
                                                        {
                                                            textStyle: Styles.redColor,
                                                            text: TMenuPollScreen[AppConfig.lang].DELETE,
                                                            onPress: () => {
                                                                setConfirmDeleteOpen(true)
                                                            }
                                                        }
                                                    ]}
                                                />
                                            }
                                        </View>
                                    </View>
                                    <View
                                        style={{
                                            flexDirection: 'row',
                                            justifyContent: 'flex-start',
                                            marginTop: 15
                                        }}
                                    >
                                        <button
                                            className={'btn btn-success'}
                                            onClick={() => {
                                                navigate('/admin/survey/results/' + poll.pol_id)
                                            }}
                                        >
                                            {TMenuPollScreen[AppConfig.lang].SEE_RESULTS}
                                        </button>
                                    </View>
                                </View>
                                :
                                null
                        }
                        <View
                            className={'card-body'}
                            style={{padding: 0}}
                        >
                            <View
                                style={{padding: 15, paddingTop: 0}}
                            >
                                {
                                    poll ?
                                        <View>
                                            <CCText
                                                style={{
                                                    marginTop: 30,
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {TMenuPollScreen[AppConfig.lang].QUESTIONS}
                                            </CCText>
                                            <View
                                                style={{
                                                    overflow: 'hidden',
                                                    overflowY: 'auto',
                                                    marginBottom: 15,
                                                }}
                                            >
                                                <ol>
                                                    {
                                                        poll.questions.map(question => <li
                                                            style={{
                                                                marginTop: 15
                                                            }}
                                                        >
                                                            <View>
                                                                {question.pqu_question}
                                                            </View>
                                                            <View
                                                                style={{
                                                                    color: 'gray'
                                                                }}
                                                            >
                                                                {question.pqu_type === PollConstants.TYPE_SCORE ? TMenuPollScreen[AppConfig.lang].SCORE : null}
                                                                {question.pqu_type === PollConstants.TYPE_OPEN ? TMenuPollScreen[AppConfig.lang].OPEN : null}
                                                            </View>
                                                        </li>)
                                                    }
                                                </ol>
                                            </View>
                                        </View>
                                        :
                                        <View
                                            style={{justifyContent: 'center', alignItems: 'center', marginTop: 15}}
                                        >
                                            <div
                                                style={{
                                                    textAlign: 'center',
                                                    marginBottom: 15
                                                }}
                                            >
                                                {TMenuPollScreen[AppConfig.lang].NO_POLL}
                                            </div>
                                            <ThemeButton
                                                text={TMenuPollScreen[AppConfig.lang].CREATE}
                                                to={'/admin/survey/creator?menuID=' + id}
                                            />
                                        </View>
                                }
                            </View>
                        </View>
                    </View>
                    <AlertModal
                        visible={confirmDeleteOpen}
                        onRequestClose={() => setConfirmDeleteOpen(false)}
                        title={TMenuPollScreen[AppConfig.lang].DELETE}
                        text={TMenuPollScreen[AppConfig.lang].DELETE_TEXT}
                        buttons={[
                            {
                                text: TMenuPollScreen[AppConfig.lang].CANCEL,
                                onPress: () => {
                                    // handle cancel button press
                                }
                            },
                            {
                                type: 'danger',
                                text: TMenuPollScreen[AppConfig.lang].DELETE,
                                onPress: async () => {
                                    try {
                                        setDeleting(true)

                                        let response = await fetch('/Poll/Delete/' + poll?.pol_id, {
                                            method: "GET", // Change this to the HTTP method you desire
                                            headers: {
                                                "Content-Type": "application/json",
                                                "Authorization": auth.token
                                            },
                                        });
                                        let responseData = await response.json();

                                        if (responseData.success) {
                                            setPoll(null)
                                        } else {
                                            console.log(responseData);
                                        }

                                        setDeleting(false)
                                    } catch (error) {
                                        console.error(error);
                                    }
                                }
                            }
                        ]}
                    />
                </View>
            </View>
        </View>
        <View style={{height: 100}}></View>
    </View>;
}

export default MenuPollScreen;